import {useFormikContext} from 'formik';
import {TaskObject} from 'api/task/types';
import {BuilderValue} from 'components/Builder';

/**
 * Get total score of the task.
 * @return {number | undefined}
 */
export function getTotalScore(): number {
  const {values} = useFormikContext<BuilderValue<TaskObject>>();
  return values.content.blocks.reduce((total, current) => {
    return total + current.score;
  }, 0)
}
